function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

var _excluded = ["config", "fullResponse", "handleError", "memoize", "onError", "onResponse", "unwrapResponse"],
    _excluded2 = ["context", "children"],
    _excluded3 = ["debounce", "context"];

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, "catch": function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { createContext, useState, useContext } from "react";
import h from "@macrostrat/hyper";
import { memoize } from "underscore";
import axios from "axios";
import useAsyncEffect from "use-async-effect";
import { debounce } from "underscore";
var apiDefaults = {
  fullResponse: false,
  handleError: true,
  memoize: false,
  onError: function onError(err, opts) {
    var _opts$error;

    var error = (_opts$error = opts.error) !== null && _opts$error !== void 0 ? _opts$error : opts;
    throw error;
  },
  onResponse: function onResponse(_) {},
  unwrapResponse: function unwrapResponse(d) {
    return d;
  }
};

function removeUndefined(o1) {
  var obj = _objectSpread({}, o1);

  Object.keys(obj).forEach(function (key) {
    if (obj[key] === undefined) {
      delete obj[key];
    }
  });
  return obj;
}

function splitConfig(props) {
  var _props$config = props.config,
      config = _props$config === void 0 ? {} : _props$config,
      fullResponse = props.fullResponse,
      handleError = props.handleError,
      memoize = props.memoize,
      onError = props.onError,
      onResponse = props.onResponse,
      unwrapResponse = props.unwrapResponse,
      axiosConfig = _objectWithoutProperties(props, _excluded);

  var legacyConfig = removeUndefined({
    fullResponse: fullResponse,
    handleError: handleError,
    memoize: memoize,
    onError: onError,
    onResponse: onResponse,
    unwrapResponse: unwrapResponse
  });

  var newConfig = _objectSpread(_objectSpread(_objectSpread({}, apiDefaults), legacyConfig), config);

  return [axiosConfig, newConfig];
}

var defaultAxios = axios.create();

function createAPIContext() {
  var _axiosInstance$defaul;

  var defaultProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _splitConfig = splitConfig(defaultProps),
      _splitConfig2 = _slicedToArray(_splitConfig, 2),
      axiosConfig = _splitConfig2[0],
      config = _splitConfig2[1];

  var axiosInstance = axios.create(axiosConfig);
  var defaultValue = {
    axiosInstance: axiosInstance,
    baseURL: (_axiosInstance$defaul = axiosInstance.defaults.baseURL) !== null && _axiosInstance$defaul !== void 0 ? _axiosInstance$defaul : "",
    config: config
  };
  return /*#__PURE__*/createContext(defaultValue);
}

var APIMethod;

(function (APIMethod) {
  APIMethod["POST"] = "POST";
  APIMethod["GET"] = "GET";
})(APIMethod || (APIMethod = {}));

var APIContext = createAPIContext();

function handleResult(_x, _x2, _x3) {
  return _handleResult.apply(this, arguments);
}

function _handleResult() {
  _handleResult = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(ctx, request, info) {
    var _error;

    var _APIHelpers, processOptions, buildURL, opts, method, params, route, cfg, res, error;

    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _APIHelpers = APIHelpers(ctx), processOptions = _APIHelpers.processOptions, buildURL = _APIHelpers.buildURL;
            opts = info.opts, method = info.method, params = info.params, route = info.route;
            cfg = processOptions(opts);
            res = null;
            error = null;
            _context2.prev = 5;
            _context2.next = 8;
            return request;

          case 8:
            res = _context2.sent;
            cfg.onResponse(res);

            if (!(res.data != null)) {
              _context2.next = 12;
              break;
            }

            return _context2.abrupt("return", cfg.unwrapResponse(res.data));

          case 12:
            _context2.next = 17;
            break;

          case 14:
            _context2.prev = 14;
            _context2.t0 = _context2["catch"](5);
            error = _context2.t0;

          case 17:
            error = (_error = error) !== null && _error !== void 0 ? _error : Error(res.statusText || "No data!");

            if (!cfg.handleError) {
              _context2.next = 23;
              break;
            }

            // Log errors if we're not throwing
            console.error(error);
            cfg.onError(error, {
              error: error,
              response: res,
              endpoint: buildURL(route, params),
              method: method
            });
            _context2.next = 24;
            break;

          case 23:
            throw error;

          case 24:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[5, 14]]);
  }));
  return _handleResult.apply(this, arguments);
}

var APIHelpers = function APIHelpers(ctx) {
  return {
    buildURL: function buildURL() {
      var route = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      // axios's getUri doesn't return baseURL for some inexplicable reason,
      // as of spring 2021.
      // this behavior could change sometime in the future...
      var uriPath = ctx.axiosInstance.getUri({
        url: route,
        params: params
      });
      return ctx.baseURL + uriPath;
    },
    processOptions: function processOptions() {
      var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var o1 = _objectSpread(_objectSpread({}, ctx.config), opts);

      if (o1.fullResponse) o1.unwrapResponse = apiDefaults.unwrapResponse;
      return o1;
    }
  };
};

var APIActions = function APIActions(ctx) {
  var axiosInstance = ctx.axiosInstance;
  return {
    post: function post(route) {
      var _params, _opts;

      var opts, params, payload;

      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      if (args.length === 3) {
        params = args[0];
        payload = args[1];
        opts = args[2];
      } else if (args.length === 2) {
        payload = args[0];
        opts = args[1];
      } else if (args.length === 1) {
        payload = args[0];
      } else {
        throw "No data to post";
      }

      (_params = params) !== null && _params !== void 0 ? _params : params = {};
      (_opts = opts) !== null && _opts !== void 0 ? _opts : opts = {};
      var req = axiosInstance.post(route, payload, {
        params: params
      });
      var info = {
        route: route,
        params: params,
        method: APIMethod.POST,
        opts: opts
      };
      return handleResult(ctx, req, info);
    },
    get: function get(route) {
      var _params2, _opts2;

      var params, opts;

      for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }

      if (args.length == 1) {
        opts = args[0];
      } else if (args.length == 2) {
        params = args[0];
        opts = args[1];
      }

      (_params2 = params) !== null && _params2 !== void 0 ? _params2 : params = {};
      (_opts2 = opts) !== null && _opts2 !== void 0 ? _opts2 : opts = {};
      var get = axiosInstance.get;
      var fn = opts.memoize ? memoize(get) : get;
      var request = fn(route, {
        params: params
      });
      var info = {
        route: route,
        params: params,
        method: APIMethod.GET,
        opts: opts
      };
      return handleResult(ctx, request, info);
    }
  };
};

function APIProvider(props) {
  var _axiosInstance$defaul2;

  /** Provider for APIContext
   can pass an alternative API context using "context" param
  */
  var _props$context = props.context,
      context = _props$context === void 0 ? APIContext : _props$context,
      children = props.children,
      rest = _objectWithoutProperties(props, _excluded2);

  var _splitConfig3 = splitConfig(rest),
      _splitConfig4 = _slicedToArray(_splitConfig3, 2),
      axiosConfig = _splitConfig4[0],
      config = _splitConfig4[1];

  var axiosInstance = axios.create(axiosConfig);
  var value = {
    axiosInstance: axiosInstance,
    baseURL: (_axiosInstance$defaul2 = axiosInstance.defaults.baseURL) !== null && _axiosInstance$defaul2 !== void 0 ? _axiosInstance$defaul2 : "",
    config: config
  };
  return h(context.Provider, {
    value: value
  }, children);
}

var useAPIActions = function useAPIActions() {
  var ctx = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : APIContext;
  return APIActions(useContext(ctx));
};

var useAPIHelpers = function useAPIHelpers() {
  var ctx = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : APIContext;
  return APIHelpers(useContext(ctx));
};

function useAxiosInstance() {
  var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : APIContext;
  return useContext(context).axiosInstance;
}

function useAPIResult(route) {
  var _opts3;

  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  /* React hook for API results */
  var deps = [route].concat(_toConsumableArray(Object.values(params !== null && params !== void 0 ? params : {})));

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      result = _useState2[0],
      setResult = _useState2[1];

  if (typeof opts === "function") {
    opts = {
      unwrapResponse: opts
    };
  }

  var _ref = (_opts3 = opts) !== null && _opts3 !== void 0 ? _opts3 : {},
      _debounce = _ref.debounce,
      context = _ref.context,
      rest = _objectWithoutProperties(_ref, _excluded3);

  var _useAPIActions = useAPIActions(context),
      get = _useAPIActions.get;

  var _getAPIData = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var res;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(route == null)) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return", setResult(null));

            case 2:
              _context.next = 4;
              return get(route, params, rest);

            case 4:
              res = _context.sent;
              return _context.abrupt("return", setResult(res));

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function _getAPIData() {
      return _ref2.apply(this, arguments);
    };
  }();

  var getAPIData = _debounce != null ? debounce(_getAPIData, _debounce) : _getAPIData;
  useAsyncEffect(getAPIData, deps);
  return result;
}

export { createAPIContext, useAxiosInstance, APIContext, APIProvider, APIActions, APIHelpers, useAPIActions, useAPIResult, useAPIHelpers };